<script setup>
const router = useRouter()
const route = useRoute()
const keyword = ref(route.query.s || '')
const { getCategories } = useDatabase()
const categories = ref([])

const menu = ref(false)

const onSearch = () => {
  router.push({
    path: '/',
    query: { s: keyword.value },
    hash: '#product-list'
  })
}

const changedMenu = (value) => {
  if (!value) setTimeout(() => menu.value = value, 10);
}

watch(() => menu.value, async aft => {
  if (aft) categories.value = await getCategories().then(items => items.filter(v => !v.parent_id && v._count.producers)).catch(_ => ([]))
})
</script>

<template>
  <div>
    <default-ui-menu :model-value="menu" @update:model-value="changedMenu">
      <template #activator>
        <button
          type="button"
          class="btn text-sm !min-w-14 !font-noto-sans"
          @click.prevent="menu = !menu"
        >
          <NuxtImg src="/icon/search.png" class="h-6 md:h-8" />
          <span class="hidden xl:inline">生産者を探す</span>
        </button>
      </template>

      <form
        class="px-3 py-4 relative border-b border-zinc-300"
        @submit.prevent="onSearch"
      >
        <input
          type="input"
          placeholder="キーワードで探す"
          v-model="keyword"
          class="input !pr-12"
        />

        <button
          type="submit"
          class="btn btn-sm btn-square btn-sm !absolute top-1/2 right-5 -translate-y-1/2"
        ><icon icon="mdi:search" width="20" /></button>
      </form>

      <div class="pb-3 max-h-80 overflow-y-auto">
        <NuxtLink
          v-for="(cat, c) of categories"
          :key="c"
          class="px-3 py-2 border-b border-zinc-300 last:border-b-0 text-lg block link hover:bg-zinc-100"
          :to="{
            path: '/',
            query: { c: cat.id },
            hash: '#product-list'
          }"
        >{{ cat.name }}</NuxtLink>
      </div>
    </default-ui-menu>
  </div>
</template>